function Icon(props) {
	const icons = {
		close: <svg className={props.className} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
			<path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
		</svg>,
		arrowLeft: <svg className={props.className} fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
			<path strokeLinecap="round" strokeLinejoin="round" d="M 15.357792,18.000001 9.0468747,11.988879 15.357792,6" />
		</svg>,
		arrowRight: <svg className={props.className} fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
			<path strokeLinecap="round" strokeLinejoin="round" d="M 9.0358842,18.000001 15.346802,11.988879 9.0358842,6" />
		</svg>
	}

	return icons[props.icon] || null;
}

export default Icon;